import React from 'react';
import {
    Box,
    Typography,
    Divider,
    Grid,
    Stack,
    Paper,
    Chip,
    useTheme
} from '@mui/material';
import {
    KingBed,
    Bathtub,
    LocalParking,
    Home,
    DirectionsBike,
    CalendarToday,
    Opacity,
    Balcony,
    Power,
    SquareFoot,
    Layers,
    Security,
    Chair,
    AcUnit,
    Wifi,
    LocalLaundryService
} from '@mui/icons-material';
import { useSelector } from 'react-redux';

const DetailsOverview = ({ propertyData }) => {
    const rawData = propertyData[0]?.ExtraData;

    const theme = useSelector((data) => data.themeValue.colors)
    const propertyDetails = [
        // { icon: <KingBed sx={{ color: theme.normal_icon }} />, label: "Bedrooms", value: "3" },
        // { icon: <Bathtub sx={{ color: theme.normal_icon }} />, label: "Bathrooms", value: "2" },
        { icon: <SquareFoot sx={{ color: theme.normal_icon }} />, label: "Land Area In SQFT", value: rawData?.LandAreaInSqFt },
        { icon: <LocalParking sx={{ color: theme.normal_icon }} />, label: "Parking", value: rawData.ParkingType === "both" ? "Car and Bike" : rawData.ParkingType === "car" ? "Car" : rawData.ParkingType === "bike" ? "Bike" : "N/A", },
        { icon: <Layers sx={{ color: theme.normal_icon }} />, label: "Parking Available", value: rawData?.ParkingAvailable },

        { icon: <CalendarToday sx={{ color: theme.normal_icon }} />, label: "Age of Building", value: rawData?.AgeOfBuilding },
        // { icon: <Balcony sx={{ color: theme.normal_icon }} />, label: "Balcony", value: "2" },
        // { icon: <Opacity sx={{ color: theme.normal_icon }} />, label: "Water Supply", value: "24/7" },
        // { icon: <Power sx={{ color: theme.normal_icon }} />, label: "Power Backup", value: "Generator" },
        // { icon: <Security sx={{ color: theme.normal_icon }} />, label: "Security", value: "Gated" },
        // { icon: <Chair sx={{ color: theme.normal_icon }} />, label: "Furnishing", value: "Semi-Furnished" },
        // { icon: <AcUnit sx={{ color: theme.normal_icon }} />, label: "AC", value: "3" },
        // { icon: <Wifi sx={{ color: theme.normal_icon }} />, label: "Internet", value: "Fiber" },
        // { icon: <LocalLaundryService sx={{ color: theme.normal_icon }} />, label: "Laundry", value: "In Unit" },
        // { icon: <Home sx={{ color: theme.normal_icon }} />, label: "Type", value: "Independent House/Villa" },

    ];

   const rawDescription = propertyData?.[0]?.Description;

let parsedDescription = [];

if (rawDescription) {
    try {
        let parsed = JSON.parse(rawDescription);

        // Handle double-encoded JSON
        if (typeof parsed === "string") {
            parsed = JSON.parse(parsed);
        }

        if (Array.isArray(parsed)) {
            parsedDescription = parsed;
        } else {
            parsedDescription = [parsed];
        }
    } catch (error) {
        parsedDescription = [rawDescription];
    }
}


    return (


        <>
            <Paper
                elevation={0}
                sx={{
                    p: { xs: 1, sm: 3 },
                    borderRadius: 3,
                    border: '1px solid',
                    // borderColor: theme.background,
                    height: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                    backgroundColor: theme.background,
                    marginBottom: 4,
                    margin: 2
                }}
            >
                {/* Property Overview Section */}
                <Box>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            color: theme.text,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            mb: 1
                        }}
                    >
                        {/* <Home fontSize="medium" /> */}
                        Property Overview
                    </Typography>
                    <Divider sx={{ mb: 2, backgroundColor: theme.secondary_text_color }} />

                    <Grid container spacing={2} sx={{
                        display: "flex", justifyContent: "start",
                        flexWrap: "wrap",
                        textAlign: "center",
                        width: "100%",
                        // backgroundColor: "blue"
                    }}>
                        {propertyDetails.map((item, index) => (
                            <Grid key={index} sx={{
                                width: { xs: "auto", sm: "30%" },
                                display: "flex",
                                justifyContent: "space-between",
                                // backgroundColor: "red"
                            }}>
                                <Box
                                    elevation={0}
                                    sx={{
                                        // width: {
                                        //     xs: '8rem',     // Extra-small devices (mobile)
                                        //     sm: '16rem',    // Small devices (tablet)
                                        //     md: '23rem',    // Medium devices (laptop)
                                        //     lg: '22rem',    // Large devices
                                        // },
                                        width: "100%",
                                        p: 1.5,
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1.5,
                                        borderBottom: '1px dotted',
                                        borderColor: theme.borderColor,
                                        transition: 'all 0.3s ease',

                                    }}
                                >
                                    <Box
                                        sx={{
                                            // p: 1,
                                            color: theme.text,
                                            borderRadius: 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        {item.icon}
                                    </Box>
                                    <Box sx={{ display: { xs: "null", sm: "flex", }, gap: 1 }}>

                                        <Typography
                                            variant="caption"

                                            sx={{ color: theme.text, }}
                                        >
                                            {item.label}
                                        </Typography>
                                        <Typography
                                            variant="subtitle2"
                                            fontWeight={600}
                                            sx={{ lineHeight: 1.2, color: theme.text, }}
                                        >
                                            {item.value}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Paper>
            {/* Description Section */}
         {Array.isArray(parsedDescription) && parsedDescription.length > 0 && (
    <Paper
        elevation={0}
        sx={{
            p: { xs: 2, sm: 3 },
            borderRadius: 3,
            border: '1px solid',
            borderColor: theme.borderColor,
            backgroundColor: theme.background,
            marginX: 2,
            marginBottom: 4
        }}
    >
        <Typography
            variant="h6"
            sx={{
                fontWeight: 700,
                color: theme.text,
                mb: 1
            }}
        >
            More About {propertyData?.[0]?.PropertyName}
        </Typography>

        <Divider sx={{ mb: 2, backgroundColor: theme.secondary_text_color }} />

        {parsedDescription.map((point, index) => (
            <Typography
                key={index}
                variant="body1"
                sx={{
                    color: theme.text,
                    lineHeight: 1.8,
                    textAlign: "justify",
                    mb: 2,
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1
                }}
            >
                • {point}
            </Typography>
        ))}
    </Paper>
)}

         

        </>
    );
};

export default DetailsOverview;